export function moveArrayItem(arr: any[], fromIndex: number, toIndex: number): void {
  const item = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, item);
}
